<template>
  <component
    :is="tag"
    :class="computedSizeClasses"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import type { BodySize, BodyVariant, BodyWeight } from './types'

const props = withDefaults(defineProps<{
  tag?: 'div' | 'p' | 'span'
  size?: BodySize
  weight?: BodyWeight
  variant?: BodyVariant
}>(), {
  tag: 'p',
  size: 'md',
  weight: 'normal',
  variant: 'default',
})

const computedSizeClasses = computed(() => {
  return [
    {
      'text-lg': props.size === 'lg',
      'text-base': props.size === 'md',
      'text-sm/5': props.size === 'sm',
      'text-xs/5': props.size === 'xs',
    },
    {
      'font-semibold': props.weight === 'semibold',
      'font-medium': props.weight === 'medium',
      'font-normal': props.weight === 'normal',
    },
    {
      'text-text-muted': props.variant === 'muted',
    },
  ]
})
</script>
